Drupal.behaviors.mainMenu = {
  attach(context) {
    // Get references to necessary elements.
    const toggleExpand = context.getElementById('toggle-expand');
    const toggleClose = context.querySelector('.toggle-expand__close');
    const mobileMenu = context.querySelector('.mobile-menu');
    const menu = context.getElementById('main-nav');

    if (menu) {
      const expandMenu = menu.getElementsByClassName('expand-sub');

      // Function to animate the slide-in effect.
      const slideInMenu = (el, duration) => {
        const element = el;
        const start = Date.now();
        const initialPosition = -100;
        const endPosition = 0;

        const animate = () => {
          const timePassed = Date.now() - start;
          let progress = timePassed / duration;
          if (progress > 1) progress = 1;

          const currentPosition =
            initialPosition + (endPosition - initialPosition) * progress;
          element.style.right = `${currentPosition}%`;

          if (progress < 1) {
            requestAnimationFrame(animate);
          }
        };

        requestAnimationFrame(animate);
      };

      // Function to animate the slide-out effect.
      const slideOutMenu = (el, duration) => {
        const element = el;
        const start = Date.now();
        const initialPosition = 0;
        const endPosition = -100;

        const animate = () => {
          const timePassed = Date.now() - start;
          let progress = timePassed / duration;
          if (progress > 1) progress = 1;

          const currentPosition =
            initialPosition + (endPosition - initialPosition) * progress;
          element.style.right = `${currentPosition}%`;

          if (progress < 1) {
            requestAnimationFrame(animate);
          }
        };

        requestAnimationFrame(animate);
      };

      // Function to reset the menu state
      const resetMenuState = () => {
        const subMenus = menu.querySelectorAll('.main-menu--sub-open');
        const openItems = menu.querySelectorAll(
          '.main-menu__item--with-sub-open',
        );

        subMenus.forEach((subMenu) => {
          subMenu.classList.remove('main-menu--sub-open');
        });

        openItems.forEach((item) => {
          item.classList.remove('main-menu__item--with-sub-open');
        });

        const expandButtons = menu.querySelectorAll('.expand-sub--open');
        expandButtons.forEach((button) => {
          button.classList.remove('expand-sub--open');
        });

        const backButtons = menu.querySelectorAll('.back-button');
        backButtons.forEach((button) => {
          button.remove();
        });
      };

      // Toggle mobile menu on click.
      toggleExpand.addEventListener('click', (event) => {
        toggleExpand.classList.toggle('toggle-expand--open');

        if (menu.classList.contains('main-nav--open')) {
          slideOutMenu(menu, 500);
          setTimeout(() => {
            menu.classList.remove('main-nav--open');
            if (mobileMenu) {
              mobileMenu.classList.remove('mobile-menu--open');
            }
          }, 100);
        } else {
          menu.classList.add('main-nav--open');
          if (mobileMenu) {
            mobileMenu.classList.add('mobile-menu--open');
          }
          slideInMenu(menu, 500);
        }

        event.preventDefault();
      });

      // Close button event listener to reset the menu state
      if (toggleClose) {
        toggleClose.addEventListener('click', () => {
          resetMenuState();
        });
      }

      // Handle sub-menu expand/collapse.
      Array.from(expandMenu).forEach((item) => {
        item.addEventListener('click', (event) => {
          const menuItem = event.currentTarget;
          const subMenu = menuItem.nextElementSibling;
          const parentMenu = menuItem.closest('.main-menu');
          const parentMenuItem = menuItem.closest('.main-menu__item');

          menuItem.classList.toggle('expand-sub--open');
          parentMenuItem.classList.toggle('main-menu__item--with-sub-open');

          if (subMenu.classList.contains('main-menu--sub-open')) {
            slideOutMenu(subMenu, 500);
            setTimeout(() => {
              subMenu.classList.remove('main-menu--sub-open');
              const backBtn = parentMenu.querySelector('.back-button');
              if (backBtn) backBtn.remove();
            }, 500);
          } else {
            subMenu.classList.add('main-menu--sub-open');
            slideInMenu(subMenu, 500);

            // Check if a back button already exists
            if (!subMenu.querySelector('.back-button')) {
              // Add a back button to the sub menu
              const backButton = document.createElement('li');
              backButton.classList.add('main-menu__item', 'back-button');
              backButton.innerHTML = `<a href="#" class="main-menu__link back-button__link">
                  <span class="back-button__text">${parentMenuItem.querySelector('.main-menu__link').innerText}</span>
                </a>`;
              backButton.addEventListener('click', (evt) => {
                evt.preventDefault();
                slideOutMenu(subMenu, 500);
                setTimeout(() => {
                  subMenu.classList.remove('main-menu--sub-open');
                  parentMenuItem.classList.remove(
                    'main-menu__item--with-sub-open',
                  );
                  backButton.remove();
                }, 500);
              });
              subMenu.prepend(backButton);
            }

            // Force reflow to ensure sub-menu is fully rendered
            // eslint-disable-next-line no-unused-expressions
            subMenu.offsetHeight;
          }
        });
      });

      // Add class to logo if menu is open
      const toggleExpandElement = document.querySelector('.toggle-expand');
      const logoLinkElement = document.querySelector('.logo__link');

      toggleExpandElement.addEventListener('click', () => {
        if (toggleExpandElement.classList.contains('toggle-expand--open')) {
          logoLinkElement.classList.add('open');
        } else {
          logoLinkElement.classList.remove('open');
        }
      });

      // Hide the last child if it's the OR&I button
      const tbmMain = context.querySelector('.tbm-main');
      if (tbmMain) {
        const menuItems = tbmMain.querySelectorAll('li.tbm-item.level-1');
        const lastItem = menuItems[menuItems.length - 1];
        if (lastItem && lastItem.textContent.trim() === 'OR&I') {
          lastItem.style.display = 'none';
        }
      }
    }
  },
};
